import { AutoFocusDirective } from './input-autofocus.directive';
import { AutoFocusModule } from '../../common/directives/auto-focus/auto-focus.module';
import { CommonModule } from '@angular/common';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { SearchBarComponent } from './search-bar.component';

@NgModule({
    declarations: [
        SearchBarComponent,
        AutoFocusDirective,
    ],
    imports: [
        AutoFocusModule,
        CommonModule,
        MatAutocompleteModule,
        MatButtonModule,
        MatIconModule,
        ReactiveFormsModule,
    ],
    exports: [
        SearchBarComponent,
    ],
})
export class SearchBarModule {}
